import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useEffect, useState } from 'react';
import uniqueId from 'lodash.uniqueid';
import { Container, Row, Col } from 'react-bootstrap'; // Design System

import Wrapper from '../wrapper/Wrapper';
import Carousel from '../carousel/Carousel';
import Heading from '../heading/Heading';
import { ProductCard, Card } from '.';
import * as UTIL from "../../util";
import { PowerReviewConfig } from "react-power-reviews";
import ducks from '../../ducks';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
var id = uniqueId();

var setModel = function setModel(item) {
  try {
    var _item$fields$cardColo, _item$fields$cardColo2;

    var cardColor = typeof item.fields.cardColor !== 'undefined' ? (_item$fields$cardColo = item.fields.cardColor) === null || _item$fields$cardColo === void 0 ? void 0 : (_item$fields$cardColo2 = _item$fields$cardColo.fields) === null || _item$fields$cardColo2 === void 0 ? void 0 : _item$fields$cardColo2.value : '';
    return _objectSpread(_objectSpread({}, item.fields), {}, {
      image: item.fields.image,
      videoUrl: item.fields.videoUrl,
      link: item.fields.link1 || {
        value: {}
      },
      link2: item.fields.link2 || {
        value: {}
      },
      link3: item.fields.link3 || {
        value: {}
      },
      title: item.fields.title,
      titleTag: item.fields.titleTag,
      subtitle: item.fields.subtitle,
      text: item.fields.text,
      linkType: item.fields.linkType || {},
      color: cardColor,
      year: item.fields.year,
      price: item.fields.price,
      calorie: item.fields.calorie,
      likes: item.fields.likes,
      available: item.fields.available,
      defaultOptions: item.fields.defaultOptions,
      tags: item.fields.tags,
      lighterFare: item.fields.lighterFare,
      servingSize: item.fields.servingSize,
      almostGoneBanner: item.fields.almostGoneBanner,
      exclusiveBanner: item.fields.exclusiveBanner,
      exclusiveText: item.fields.exclusiveText,
      sku: item.fields.sku,
      productId: item.fields.productId,
      isFavorite: item.fields.isFavorite,
      id: item.id
    });
  } catch (e) {
    return {
      image: {
        value: {}
      },
      videoUrl: {
        value: {
          href: ""
        }
      },
      link: {
        value: {}
      },
      link2: {
        value: {}
      },
      title: {
        value: ""
      },
      titleTag: {
        value: ""
      },
      subtitle: {
        value: ""
      },
      text: {
        value: ""
      },
      linkType: {},
      color: "",
      year: {
        value: ""
      },
      price: {
        value: ""
      },
      calorie: {
        value: ""
      },
      likes: {
        value: ""
      },
      available: {
        value: ""
      },
      defaultOptions: [],
      tags: "",
      lighterFare: "",
      servingSize: "",
      almostGoneBanner: "",
      exclusiveBanner: "",
      exclusiveText: "",
      sku: "",
      productId: "",
      isFavorite: false,
      id: ""
    };
  }
};

var CardList = function CardList(props) {
  var _props$personalize2;

  var _props$cards = props.cards,
      cards = _props$cards === void 0 ? [] : _props$cards,
      _props$totalCardsInRo = props.totalCardsInRow,
      totalCardsInRow = _props$totalCardsInRo === void 0 ? 1 : _props$totalCardsInRo,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      isEditing = props.isEditing,
      _props$isProduct = props.isProduct,
      isProduct = _props$isProduct === void 0 ? false : _props$isProduct,
      _props$isRetail = props.isRetail,
      isRetail = _props$isRetail === void 0 ? false : _props$isRetail,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      saveDefault = props.saveDefault,
      _props$showArrows = props.showArrows,
      showArrows = _props$showArrows === void 0 ? false : _props$showArrows,
      isLoading = props.isLoading;
  var _props$cardDisplayTyp = props.cardDisplayType,
      cardDisplayType = _props$cardDisplayTyp === void 0 ? 'carousel' : _props$cardDisplayTyp;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      cardsInfo = _useState2[0],
      setCardsInfo = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      cardsInitialState = _useState4[0],
      setCardsInitialState = _useState4[1];

  useEffect(function () {
    var cardsState = cards.map(function (card) {
      return setModel(card);
    });
    setCardsInfo(cardsState);
    setCardsInitialState(cardsState);
  }, [cards]);
  useEffect(function () {
    if (isRetail) {
      var reviewConfig = _objectSpread({}, UTIL.powerReviewConfig);

      var snippets = cardsInfo.map(function (card) {
        return card.sku;
      });

      if (snippets.includes(undefined)) {
        return;
      }

      reviewConfig.component = {
        categorySnippets: "powerReviews-sku"
      };
      reviewConfig.categorySnippets = {
        // This is the base id of the div that you will use
        id: "powerReviews-sku",
        // powerReviews-sku-583514
        snippets: snippets
      };
      PowerReviewConfig(reviewConfig);
    }
  }, [cardsInfo]);
  var totalShow = parseInt(totalCardsInRow);

  if (cardsInfo.length < parseInt(totalCardsInRow)) {
    cardDisplayType = "list"; //totalShow = cards.length;
  }

  var columns = Math.ceil(12 / parseInt(totalCardsInRow));
  var carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: totalShow,
    slidesToScroll: totalShow,
    arrows: true,
    responsive: [{
      breakpoint: 780,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '8%',
        centerMode: true,
        arrows: false
      }
    }, {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
        arrows: false
      }
    }]
  };
  var CardType = isProduct ? ProductCard : Card;
  var flags = useFlags();
  var releasePersonalizationActionCard = flags['releasePersonalizationActionCard'] ? flags['releasePersonalizationActionCard'] : false;

  var _useState5 = useState(typeof window.engage !== 'undefined' ? true : false),
      _useState6 = _slicedToArray(_useState5, 2),
      engageAvailable = _useState6[0],
      setEngageAvailable = _useState6[1];

  useEffect(function () {
    if (!releasePersonalizationActionCard) {
      return;
    } // Set a timer to periodically check for window.engage availability


    var checkEngageAvailability = setInterval(function () {
      if (window.engage) {
        setEngageAvailable(true);
        clearInterval(checkEngageAvailability);
      }
    }, 1000); // Cleanup function to clear the timer when the component unmounts

    return function () {
      clearInterval(checkEngageAvailability);
    };
  }, [releasePersonalizationActionCard]);
  useEffect(function () {
    if (!releasePersonalizationActionCard) {
      setCardsInfo(cardsInitialState);
      return;
    }

    if (engageAvailable && cardsInfo.length) {
      // window.engage is available, verify if the component has personalizationScenario info
      var promises = cardsInitialState.map( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(card) {
          var _card$personalization, _card$personalization2, _card$personalization3;

          var _props$personalize, _personalizeFields$pr, _personalizeFields$pr2, _card$image, _personalizeFields$pr3, _personalizeFields$pr4, _personalizeFields$pr5, _personalizeFields$pr6, _personalizeFields$pr7, _personalizeFields$pr8, _personalizeFields$pr9, _personalizeFields$pr10, _card$link, _personalizeFields$pr11, _personalizeFields$pr12, _personalizeFields$pr13, _personalizeFields$pr14, _personalizeFields$pr15, _personalizeFields$pr16, _personalizeFields$pr17, personalizeFields;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(card === null || card === void 0 ? void 0 : (_card$personalization = card.personalizationScenario) === null || _card$personalization === void 0 ? void 0 : (_card$personalization2 = _card$personalization.fields) === null || _card$personalization2 === void 0 ? void 0 : (_card$personalization3 = _card$personalization2.FriendlyID) === null || _card$personalization3 === void 0 ? void 0 : _card$personalization3.value)) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 3;
                  return props.getPersonalizeInfo(card.id, card.personalizationScenario.fields.FriendlyID.value, (_props$personalize = props.personalize) === null || _props$personalize === void 0 ? void 0 : _props$personalize.pageViewData);

                case 3:
                  personalizeFields = _context.sent;
                  return _context.abrupt("return", _objectSpread(_objectSpread({}, card), {}, {
                    image: {
                      value: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr = personalizeFields.promoData) === null || _personalizeFields$pr === void 0 ? void 0 : (_personalizeFields$pr2 = _personalizeFields$pr.PromoImage) === null || _personalizeFields$pr2 === void 0 ? void 0 : _personalizeFields$pr2.value) || (card === null || card === void 0 ? void 0 : (_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.value)
                    },
                    title: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr3 = personalizeFields.promoData) === null || _personalizeFields$pr3 === void 0 ? void 0 : (_personalizeFields$pr4 = _personalizeFields$pr3.Header) === null || _personalizeFields$pr4 === void 0 ? void 0 : _personalizeFields$pr4.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr5 = personalizeFields.promoData) === null || _personalizeFields$pr5 === void 0 ? void 0 : _personalizeFields$pr5.Header : card.title,
                    text: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr6 = personalizeFields.promoData) === null || _personalizeFields$pr6 === void 0 ? void 0 : (_personalizeFields$pr7 = _personalizeFields$pr6.Copy) === null || _personalizeFields$pr7 === void 0 ? void 0 : _personalizeFields$pr7.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr8 = personalizeFields.promoData) === null || _personalizeFields$pr8 === void 0 ? void 0 : _personalizeFields$pr8.Copy : card.text,
                    link: {
                      value: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr9 = personalizeFields.promoData) === null || _personalizeFields$pr9 === void 0 ? void 0 : (_personalizeFields$pr10 = _personalizeFields$pr9.Link) === null || _personalizeFields$pr10 === void 0 ? void 0 : _personalizeFields$pr10.value) || (card === null || card === void 0 ? void 0 : (_card$link = card.link) === null || _card$link === void 0 ? void 0 : _card$link.value)
                    },
                    color: (personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr11 = personalizeFields.promoData) === null || _personalizeFields$pr11 === void 0 ? void 0 : (_personalizeFields$pr12 = _personalizeFields$pr11.BackgroundColor) === null || _personalizeFields$pr12 === void 0 ? void 0 : (_personalizeFields$pr13 = _personalizeFields$pr12.fields) === null || _personalizeFields$pr13 === void 0 ? void 0 : (_personalizeFields$pr14 = _personalizeFields$pr13.value) === null || _personalizeFields$pr14 === void 0 ? void 0 : _personalizeFields$pr14.value) ? personalizeFields === null || personalizeFields === void 0 ? void 0 : (_personalizeFields$pr15 = personalizeFields.promoData) === null || _personalizeFields$pr15 === void 0 ? void 0 : (_personalizeFields$pr16 = _personalizeFields$pr15.BackgroundColor) === null || _personalizeFields$pr16 === void 0 ? void 0 : (_personalizeFields$pr17 = _personalizeFields$pr16.fields) === null || _personalizeFields$pr17 === void 0 ? void 0 : _personalizeFields$pr17.value : card.color
                  }));

                case 7:
                  return _context.abrupt("return", card);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      Promise.all(promises).then(function (cardsNewState) {
        setCardsInfo(cardsNewState);
      });
    }
  }, [engageAvailable, (_props$personalize2 = props.personalize) === null || _props$personalize2 === void 0 ? void 0 : _props$personalize2.pageViewData, releasePersonalizationActionCard, cardsInitialState]);

  var Body = function Body(props) {
    var _props$cardsInfo$, _props$cardsInfo$$fie, _props$cardsInfo$$fie2;

    var carouselClass = props.carouselClass,
        containerClass = props.containerClass;
    return /*#__PURE__*/React.createElement(Wrapper, {
      layout: layout
    }, /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(carouselClass !== "d-none") && /*#__PURE__*/React.createElement("div", {
      className: "\n      ".concat(carouselClass, "\n    ")
    }, /*#__PURE__*/React.createElement(Carousel, {
      settings: carouselSettings,
      type: "spaced"
    }, props.cardsInfo && props.cardsInfo.map(function (card, index) {
      return /*#__PURE__*/React.createElement(CardType, _extends({
        isEditing: isEditing,
        model: card,
        key: "cards-slide-".concat(id, "-").concat(index)
      }, props, {
        isPromoProduct: true
      }));
    }))), /*#__PURE__*/React.createElement(Container, {
      className: "\n      ".concat(containerClass, "\n      ").concat(isProduct ? 'cb-card--small' : '', "\n      ").concat(isRetail ? 'cb-card--retail' : '', "\n\n    ")
    }, props.cardsInfo && ((_props$cardsInfo$ = props.cardsInfo[0]) === null || _props$cardsInfo$ === void 0 ? void 0 : (_props$cardsInfo$$fie = _props$cardsInfo$.fields) === null || _props$cardsInfo$$fie === void 0 ? void 0 : (_props$cardsInfo$$fie2 = _props$cardsInfo$$fie.year) === null || _props$cardsInfo$$fie2 === void 0 ? void 0 : _props$cardsInfo$$fie2.value) ? /*#__PURE__*/React.createElement(Timeline, {
      cardsInfo: props.cardsInfo,
      isEditing: isEditing
    }) : /*#__PURE__*/React.createElement(BasicList, _extends({
      columns: columns,
      isEditing: isEditing,
      cardsInfo: props.cardsInfo,
      cards: cards,
      addToOrder: addToOrder,
      noLocation: noLocation,
      saveDefault: saveDefault,
      CardType: CardType
    }, props, {
      isPromoProduct: true
    })))));
  };

  return isProduct ? /*#__PURE__*/React.createElement(Body, _extends({
    carouselClass: cardDisplayType !== 'carousel' ? 'd-none' : "",
    containerClass: cardDisplayType !== 'carousel' ? 'd-block' : "d-none"
  }, props, {
    cardsInfo: cardsInfo
  })) : /*#__PURE__*/React.createElement(Body, _extends({
    carouselClass: cardDisplayType !== 'carousel' ? 'd-md-none' : "",
    containerClass: cardDisplayType !== 'carousel' ? 'd-none d-md-block' : "d-none"
  }, props, {
    cardsInfo: cardsInfo
  }));
};

var Timeline = function Timeline(_ref2) {
  var cardsInfo = _ref2.cardsInfo,
      isEditing = _ref2.isEditing;
  return /*#__PURE__*/React.createElement(Row, {
    className: "pt-100__1212"
  }, cardsInfo.map(function (card, index) {
    var diviseby2 = Boolean(index % 2);
    return /*#__PURE__*/React.createElement(Col, {
      lg: 12,
      sm: "12",
      className: "".concat(isEditing ? "cb-card--scEdit" : ""),
      key: "cards-col-".concat(id, "-").concat(index)
    }, /*#__PURE__*/React.createElement(Row, {
      className: "".concat(index !== 0 ? "cb-card__timelinerow mt-neg150" : "cb-card__timelinerow cb-card__timelinerow--first")
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
      isEditing: isEditing,
      model: card,
      isTimeline: true,
      className: diviseby2 ? "left" : "right",
      cards: cardsInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-card__timelinerunner ".concat(index === cardsInfo.length - 1 ? "cb-card__timelinerunner--last" : "", " ").concat(diviseby2 ? "left" : "right")
    }), /*#__PURE__*/React.createElement(Heading, {
      level: "4",
      field: card.year,
      className: "cb-card__timelineyear ".concat(diviseby2 ? "left" : "right")
    })))));
  }));
};

var BasicList = function BasicList(props) {
  var columns = props.columns,
      isEditing = props.isEditing,
      cardsInfo = props.cardsInfo,
      CardType = props.CardType,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      saveDefault = props.saveDefault;
  return /*#__PURE__*/React.createElement(Row, null, cardsInfo.map(function (card, index) {
    return /*#__PURE__*/React.createElement(Col, {
      lg: columns,
      md: "6",
      className: "cb-l-margin-medium--bottom ".concat(isEditing ? "cb-card--scEdit" : ""),
      key: "cards-col-".concat(id, "-").concat(index)
    }, /*#__PURE__*/React.createElement(CardType, _extends({
      model: card
    }, props, {
      isPromoProduct: true,
      props: props
    })));
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    personalize: state.personalize
  };
};

var personalizeOperations = ducks.personalize.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPersonalizeInfo: function getPersonalizeInfo(id, friendlyId, pageViewData) {
      return dispatch(personalizeOperations.handleGetPersonalizeInfo(id, friendlyId, pageViewData));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardList);